<template>
  <div class="uk-position-relative">
    <div id="map-container"></div>

    <div v-if="props.externalMapUrl != null && props.externalMapUrl != ''">

    <a
    id="map-expand"
      class="uk-button uk-flex uk-text-medium uk-flex-middle uk-button-primary uk-position-z-index"
      href="#map-modal"
      uk-toggle>
        <span uk-icon="nv-expand"></span>
        <span class="uk-visible@m uk-margin-xsmall-left">Detaljert kart</span>
      </a>

      <div id="map-modal" class="uk-flex-top uk-position-cover uk-padding-remove" uk-modal>
      <div class="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">
        <div v-if="projectTitle" class="uk-overlay uk-overlay-default uk-position-top-left">
          <div class="uk-h5">
            {{projectTitle}}
          </div>
        </div>

        <button class="uk-flex uk-flex-middle uk-text-medium uk-button uk-button-primary uk-modal-close-default" type="button">
          <span class="uk-margin-xsmall-right" uk-icon="nv-minimize"></span>
          <span>Lukk</span>
        </button>

        <iframe style="height: 100vh; width: 100vw;"
          :src="props.externalMapUrl"
          width="100vw" height="100vh" uk-video uk-responsive></iframe>
      </div>
    </div>

    </div>

  </div>
</template>

<script setup lang="ts">
import {onMounted, reactive, ref} from 'vue'
import * as L from 'leaflet'
import 'leaflet.markercluster'
import { FeatureLayer, query } from 'esri-leaflet'
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet/dist/leaflet.css";
import * as Vector from 'esri-leaflet-vector'
import { IFeatureLayerOptions } from '@/interfaces/FeatureLayerOptions'
import { CustomMarker } from './CustomMarker'
import { IMarkerContent } from '@/interfaces/MarkerContent'

onMounted( () => {
  init()
})

const props = defineProps({
  showObjects: {
    type: String,
    required: true
  },
  externalMapUrl: {
    type: String,
    required: false
  },
  projectTitle: {
    type: String,
    required: false
  }
})

const state = reactive({
  baseLayer:  null as any | null,
  basemapPortalUrl: "https://nyeveieras.maps.arcgis.com" as string,
  basemapStyle: "ca6a11e1c7774d79a5259c4c622223f1" as string,
  markerContent : [] as IMarkerContent[],
  markers: L.markerClusterGroup({
    removeOutsideVisibleBounds: true,
    showCoverageOnHover: false,
    maxClusterRadius: function (zoom: number) {
        return (zoom >= 10 ? 1 : 35);
      }
  }),
})

const map = ref(null as any)
const featureLayers = ref([] as L.esri.FeatureLayer[])

async function init() {
  // Initialize the map
  L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

 map.value = L.map('map-container', {
   zoomControl: false,
   minZoom: 6,
   maxZoom: 15,
   dragging: true,
   scrollWheelZoom: false,
   attributionControl: false,
   gestureHandling: true,
 })
  if (props.showObjects) {
    state.markerContent = JSON.parse(props.showObjects)
  }

 addMapControls()

  //setBaseMapLayer(state.basemapStyle, state.basemapPortalUrl)
 setBaseMapLayer("https://vector.services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheKanvas_WM/VectorTileServer/")

  //const layerBounds = await getLayerBounds("https://services-eu1.arcgis.com/Zxn04POL7OfqZkir/arcgis/rest/services/Prosjektstatus_gdb/FeatureServer/0")
  //
  const layerBounds = await getLayerBounds("https://services-eu1.arcgis.com/Zxn04POL7OfqZkir/arcgis/rest/services/NV_SenterlinjePortefolje_Niv0/FeatureServer/0")


  if (layerBounds && layerBounds.isValid()) {
  // Set map bounds to show the active features
  map.value.fitBounds(layerBounds)
	} else {
	console.log('No valid bounds found')
 }

  const featureLayerData = await getMapFeatureLayers("https://services-eu1.arcgis.com/Zxn04POL7OfqZkir/arcgis/rest/services/NV_SenterlinjePortefolje_Niv0/FeatureServer/0")
  if(featureLayerData){
    featureLayers.value.push(featureLayerData.layer)
  }
 /*const featureLayerData = await getMapFeatureLayers("https://nyeveier.cloudgis.no/enterprise/rest/services/Hosted/NyeVeierStrekningerNiv0/FeatureServer/0")
  featureLayers.value.push(featureLayerData.layer)
 console.log(featureLayers.value)*/
}
function addMapControls() {
  // Add zoom control
  L.control.zoom({
    position: 'bottomright'
  }).addTo(map.value);

}
async function getLayerBounds(url: string): Promise<L.LatLngBounds> {
 interface IQueryOptions {
 url: string
 where?: string
 }

 const queryOptions: IQueryOptions = {
 url: url
 }
 return new Promise((resolve, reject) => {

	 const boundsQuery = query(queryOptions);



 boundsQuery.run((error, featureCollection) => {
  if (error) {
    console.error('Failed to get feature layer bounds:', error);
    reject()
  } else {
    // Create an empty LatLngBounds object
    let bounds = L.latLngBounds([]);
		const showObjectsArray = state.markerContent.map(item => item.Name)
    // Iterate over the features in the feature collection
    for (let feature of featureCollection.features) {
      // Extend the bounds to include the geometry of the feature
      if (showObjectsArray.includes(feature.properties.parsell)) {
        if (feature.geometry.type === 'MultiLineString') {
          // If it's a MultiLineString, iterate over each LineString
          for (let line of feature.geometry.coordinates) {
            // Swap the order of the coordinates
            let swappedCoordinates = line.map((coord: any) => [coord[1], coord[0]]);
            // Create a LatLngBounds object for the LineString
            let featureBounds = L.latLngBounds(swappedCoordinates);
            // Merge the feature bounds with the total bounds
            bounds.extend(featureBounds);
          }
        } else {
          // Swap the order of the coordinates
          let swappedCoordinates = feature.geometry.coordinates.map((coord: any) => [coord[1], coord[0]]);
          // Create a LatLngBounds object for the feature
          let featureBounds = L.latLngBounds(swappedCoordinates);
          // Merge the feature bounds with the total bounds
          bounds.extend(featureBounds);
        }
      }
    }
    resolve(bounds);
  }
 })
 })
}

function getFeatureColor(feature: any) {
  const status = state.markerContent.find(item => item.Name.replace('.','') === feature.properties?.parsell)?.Status
  let color;
  if (status === 'Building') {
    color = '#F58500';
  } else if (status == 'Preparing') {
    color = '#FF5BD1';
  } else if (status == 'Planning') {
    color = '#EF281F';
  } else if (status == 'Completed') {
    color = '#006210';
  } else {
    color = '#F13F37';
  }
  return color;
}

function getMapFeatureLayers(url: string): Promise<{ layer: L.esri.FeatureLayer }> {

  return new Promise((resolve) => {
    const featureOptions: IFeatureLayerOptions = {
      url: url,
      apiKey: import.meta.env.VITE_APP_ARCGIS_API_KEY,
      simplifyFactor: 0.35,
      precision: 5,
      f: 'json',
      style: (feature: any) => {
        return { color: getFeatureColor(feature), weight: 5 };
      }
    }

    if (state.markerContent != null && state.markerContent.length > 0) {
      //featureOptions.where = `PARSELL IN ('${state.markerContent.map(item => item.Name).join("','")}')`
      featureOptions.where = `parsell IN ('${state.markerContent.map(item => item.Name).join("','")}')`;
		}
    const featureLayer = new FeatureLayer(featureOptions).addTo(map.value);

    featureLayer.on('createfeature', (event: any) => {
      if (!event.feature.properties.parsell) return
      const coordinates = event.feature.geometry.coordinates;
      const polylinePoints: any = [];

      if (event.feature.geometry.type === 'LineString') {
        // If geometry type is LineString, loop over coordinates
        coordinates.forEach((coord: any) => polylinePoints.push([coord[1], coord[0]]));
      } else if (event.feature.geometry.type === 'MultiPolygon') {
        coordinates.forEach((polygon: any) => {
          polygon.forEach((ring: any) => {
            ring.forEach((coord: any) => polylinePoints.push([coord[1], coord[0]]));
          });
        });
      } else {
        // If not LineString, perhaps MultiLineString or other type
        coordinates.forEach((line: any) => {
          line.forEach((point: any) => polylinePoints.push([point[1], point[0]]));
        });
      }
      const middlePoint = polylinePoints[Math.floor(polylinePoints.length / 2)];

      const markerContent = state.markerContent.find(item => item.Name === event.feature.properties.parsell)

      if (markerContent != null && markerContent?.ShowMarker == null || markerContent != null && markerContent.ShowMarker == true) {

        const marker = CustomMarker(middlePoint, markerContent)
        try {
          state.markers.addLayer(marker); // Add marker to cluster group
          // Save the marker in the mapping object
        } catch (error) {
          console.error(error)
        }
      }
    })
    state.markers.addTo(map.value)
    resolve({ layer: featureLayer });
  })
}
function setBaseMapLayer(url: string) {
  try {
    if (map.value) {
      if (state.baseLayer && map.value.hasLayer(state.baseLayer)) {
        map.value.removeLayer(state.baseLayer); // Remove the current base layer if it exists
      }
      if (url.includes('VectorTileServer')) {
        state.baseLayer = Vector.vectorTileLayer(url, {}).addTo(map.value);
      } else {
        state.baseLayer = L.tileLayer(url + '/tile/{z}/{y}/{x}', {}).addTo(map.value);
      }
    }
  } catch (error) {
    console.error(error);
  }
}


</script>
<style>
#map-expand{
  position: absolute;
  bottom: 99px;
  right: 16px;
  padding: 8px;
  line-height: 50px;
  border-bottom-left-radius: 8px;
  border-top-right-radius: 8px;
}
#map-container{
  height: 60vh;
  width: 100vw;
  max-width: 100%;
  position: relative;
  z-index: 1;
  background-color: #FFF;
}
.custom-marker {
  transform-style: flat!important;
}
.custom-marker:hover .icon-container,
.custom-marker:focus .icon-container{
  background-color: #D6F19B;
  color: #285960;
}
.custom-marker .icon-container{
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #285960;
  color: #FFF;
  border-radius: 4px;
  border: 1px solid #285960;
}
.custom-marker .icon-container.mainProject{
  background-color: #FFE5FA;
}
.custom-marker .icon-container:after{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    width: 0;
    height: 0;
}

.icon-container:before {
content: '';
display: block;
position: absolute;
top: 100%;
left: 50%;
width: 10px;
height: 10px;
background-color: #285960;
border-right:1px solid #285960;
border-bottom:1px solid #285960;
transform: translate(-50%, -5px) rotate(45deg);
}
.icon-container:hover:before{
background-color: #D6F19B;
}
.custom-popup{
  font-size: 14px;
}
.custom-popup .leaflet-popup-content-wrapper{
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
}
.custom-popup .leaflet-popup-content-wrapper,
.custom-popup .leaflet-popup-tip{
  background-color: #285960;
  color: #FFF;
}
.custom-popup a.leaflet-popup-close-button{
  right: 5px;
}
.custom-popup a.leaflet-popup-close-button,
.custom-popup a.leaflet-popup-close-button:hover{
  color: #FFF;
}
.custom-popup a.leaflet-popup-close-button > span{
  font-size: 0;
}
.custom-popup a{
  color: #FFF;
  text-decoration: underline;
  font-size: 1rem;
}
.marker-cluster{
  border-radius: 50%;
  background-color: #285960;
  border: 1px solid #285960;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
  opacity: .85;
  transition: all .2s ease-in-out;
}
.marker-cluster:hover{
  background-color: #D6F19B;
  color: #285960;
  opacity: 1;
}
.leaflet-right .leaflet-control{
  margin-right: 16px;
}
.leaflet-bottom .leaflet-control {
  margin-bottom: 16px;
}
.leaflet-bar.leaflet-control-zoom{
  border: none;
   > a{
    background-color: #285960;
    color: #FFF;
    padding: 3px;
    &:focus,
    &:hover{
      background-color: #d6f19b;
      color: #285960;
    }
    &:first-child{
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
    }
    &:last-child{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius:  8px;
    }
  }
}
@media(min-width: 680px){
  #map-expand{
    padding: 12px;
    bottom: 121px;
  }
  .leaflet-bar.leaflet-control-zoom>a{
    padding: 7px;
  }
}
@media(min-width: 1024px){
  #map-expand{
    top: 32px;
    right: 32px;
    bottom: auto;
    padding: 12px 20px;
    line-height: 27px;
  }
  .leaflet-right .leaflet-control{
    margin-right: 32px;
    margin-bottom: 32px;
  }
}
</style>